var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-app',[_c('m-menu',[_c('m-menu-item',{attrs:{"title":_vm.getLang('cargo', 'list')},nativeOn:{"click":function($event){_vm.openTab('list/basic/cargo', _vm.getLang('cargo', 'list'))}}}),_c('m-menu-item',{attrs:{"title":_vm.getLang('menu.logout')},nativeOn:{"click":function($event){return (() => {
          _vm.$router.push({ path: '/companylogin' });
        }).apply(null, arguments)}}})],1),_c('m-tab',{ref:"mainAppTab"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }